import { Show } from './show';

/** Branding for a show card, keyed by lowercase show code. */
export type ShowPresentation = Pick<Show, 'monogram' | 'accent' | 'logoUrl' | 'tint' | 'cta'>;

/** Accent for a show with no preset of its own. */
export const DEFAULT_SHOW_ACCENT = 'var(--p-app-brand-blue)';
export const DEFAULT_SHOW_TINT = 'var(--p-app-pick-show-surface)';
export const DEFAULT_SHOW_CTA = 'var(--p-app-accent-info)';

/** Card branding per show. Static until the logo/colour live in the DB. */
export const SHOW_PRESENTATION: Record<string, ShowPresentation> = {
  sa: {
    monogram: 'SA',
    accent: 'var(--p-app-show-sa-card)',
    logoUrl: '/assets/images/sa/san-antonio-logo.png',
    tint: 'var(--p-app-show-sa-tint)',
    cta: 'var(--p-app-show-sa-gradient)'
  },
  fourh: {
    monogram: '4H',
    accent: 'var(--p-app-show-fourh-accent)',
    logoUrl: '/assets/images/4h/H4_logo.png',
    tint: 'var(--p-app-show-fourh-tint)',
    cta: 'var(--p-app-show-fourh-gradient)'
  },
  hdgs: {
    monogram: 'HD',
    accent: 'var(--p-app-show-hdgs-accent)',
    logoUrl: '/assets/images/hill/hill-district-logo.png',
    tint: 'var(--p-app-show-hdgs-tint)',
    cta: 'var(--p-app-show-hdgs-gradient)'
  },
  ra: {
    monogram: 'RA',
    accent: DEFAULT_SHOW_ACCENT,
    logoUrl: null,
    tint: DEFAULT_SHOW_TINT,
    cta: DEFAULT_SHOW_CTA
  }
};
